import { styled } from "@mui/system";
import { Button } from "@mui/material";
import COLORS from "../../../../../theme/Colors";
import FONTS_FAMILY from "../../../../../theme/FontsFamily";

export const Container = styled("div")({
  display: "flex",
  zIndex: 1000,
  flexDirection: "row",
  backgroundColor: COLORS.white,
  justifyContent: "center",
  alignItems: "center",
  alignSelf:'center',
  height: "130px",
  width: "100%",
  maxWidth: '1920px',

  /*"&:hover,&:focus,&:active": {
    borderBottom: '3px solid green'
    //  backgroundColor: COLORS.grayHover,
  },*/

});
export const PrimaryDivider = styled('div')({
  display: 'flex',
  position:'absolute',
  width: '100%',
  height: '10px',
  top:0,
  bottom:0,
  backgroundColor:COLORS.primary,
});
export const LineContainer = styled('div')({
  display: 'flex',
  position: 'relative',
  flexDirection: 'row',
  alignSelf:'center',
  alignItems: 'center',
  width: '80%',
  justifyContent: 'space-between',
  height: '100%',
});

export const MenuContainer = styled("div")({
  display: "flex",
  flexDirection: "row",

  minheight: '100%'
});

export const DrawerMenuContainer = styled("div")({
  display: "flex",
  flexDirection: "row",
});

export const MenuButton = styled(Button, { shouldForwardProp: (prop) => prop !== 'active' && prop !== 'fontWhite' && prop !== 'padding' && prop !== 'backgroundColor' && prop !== 'borderRadius' })(props => ({
  height:'130px',
  color: props.fontWhite ? COLORS.white : COLORS.secondary,
  fontFamily: FONTS_FAMILY.medium.body,
  padding: props.padding ? `10px` : 0,
  backgroundColor: props.backgroundColor ? COLORS.primary : null,
  borderRadius: props.borderRadius ? '50px' : null,
  borderBottom: props.active ? `5px solid${COLORS.primary}` : null,
  "&:hover,&:focus,&:active": {
    borderBottom: `5px solid${COLORS.primary} `
    //  backgroundColor: COLORS.grayHover,
  },
  "@media (min-width:320px)": {
    fontSize: '12.5px',
    fontWeight: 800
  },
  "@media (min-width:768px)": {

  },
  "@media (min-width:1200px)": {

    fontSize: '15px'
  },
}));

export const MenuButtonSecondary = styled(Button, { shouldForwardProp: (prop) => prop !== 'padding' && prop !== 'borderRadius' })(props => ({
  alignSelf:'center',
  height:'50px',
  color:COLORS.white,
  fontFamily: FONTS_FAMILY.medium.body,
  padding: `10px`,
  backgroundColor: COLORS.primary,
  borderRadius: '50px',
  "&:hover,&:focus,&:active": {
   // borderBottom: `5px solid${COLORS.primary} `
      backgroundColor: COLORS.primary,
  },
  "@media (min-width:320px)": {
    fontSize: '12.5px',
    fontWeight: 800
  },
  "@media (min-width:768px)": {

  },
  "@media (min-width:1200px)": {

    fontSize: '17px'
  },
}));

export const TraslateButton = styled(Button)(props => ({
  fontSize: "15px",
  color: COLORS.secondary,
  fontFamily: FONTS_FAMILY.medium.body,
  border: props.border ? ` 1px solid ${COLORS.secondary}` : 0,
  borderRadius: '50%',
  padding: props.padding ? `8px` : 0,
}));

export const MenuDivider = styled("div")({
  width: "16px",

});
export const Image = styled("img")({
  ':hover': {
    cursor: 'pointer',
  },
  marginRight: '10px',
  "@media (min-width:320px)": {
    width: "160px",
  },
  "@media (min-width:768px)": {
    width: "180px",
  },
  "@media (min-width:1200px)": {
    width: "200px",
  },
  "@media (min-width:1400px)": {
    width: "300px",
  },
});

